import { render, staticRenderFns } from "./FaceInput.vue?vue&type=template&id=03daae56&scoped=true"
import script from "./FaceInput.vue?vue&type=script&lang=js"
export * from "./FaceInput.vue?vue&type=script&lang=js"
import style0 from "./FaceInput.vue?vue&type=style&index=0&id=03daae56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03daae56",
  null
  
)

export default component.exports